export class ClientCaseId {
   plain: string;
   main = [] ;
   partial = [];
}
